/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { observable } from 'mobx'
import { ILandingPageStateManager, IProductCategoryList, IProductCategoryInformation, IProductInformation } from './contracts'
import ILandingPageApiClient from '../LandingPageApiClient/contracts'
import { injectProperty } from '../../configuration/ServiceLocator'
import jwt_decode from 'jwt-decode'
import { injectable } from 'inversify'

@injectable()
export class LandingPageStateManager implements ILandingPageStateManager {
	@observable
	productCategoryList!: IProductCategoryList

	@observable
	userName!: string

	@injectProperty('ILandingPageApiClient')
	public landingPageApiClient!: ILandingPageApiClient

	/**
	 *
	 */
	constructor() {
		this.productCategoryList = {
			productCategoryList: [],
		} as IProductCategoryList
	}

	setProductCategoryList(productCategoryList: IProductCategoryList): void {
		this.productCategoryList = productCategoryList
	}

    getProductCategoryList(): Promise<void> {
        this.landingPageApiClient.getProductCategoryList().then((token: string) => {
            let tokenObject: any = jwt_decode(token)
            this.userName = tokenObject.name
            this.getFormattedResult(tokenObject.AbilityProductCategoryClaimV2.productCategories);
        }).catch(error => {
            console.log(error)
            throw new Error('An error occured while fetching the CMS token from Ability Portal.')
        })

		return new Promise<void>(resolve => resolve())
	}

	getFormattedResult(response: any) {
		const result = { productCategoryList: [] } as IProductCategoryList
		response.map((item: any, index: number) => {
			result.productCategoryList.push({
				productCategoryId: item.ProductCategoryId,
				productCategoryName: item.Caption,
				sequence: item.Sequence,
				ProductInfos: this.getProductList(item.HomeIndexProductsViewModel),
			} as IProductCategoryInformation)
		})
		this.setProductCategoryList(result)
	}

	getProductList(productList: any) {
		const productResult = [] as IProductInformation[]
		productList.map((productItem: any, index: number) => {
			productResult.push({
				code: productItem.Code,
				name: productItem.Name,
				sequence: productItem.Sequence,
			} as IProductInformation)
		})

		return productResult
	}
}
